import { useDispatch, useSelector } from "react-redux";
import Footer from "../../SharedModule/components/Footer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  CLIENTS_ALL_ROLES,
  ROLE_CLIENT_ADMIN,
  ROLE_SUPER_ADMIN,
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS,
  ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW_TAB,
} from "../../SharedModule/utils/constants";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { useNavigate, useParams, Link, useLocation } from "react-router";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { useEffect, useRef } from "react";
import HeaderClientsModule from "../components/HeaderClientsModule";
import { ClientKeyContact } from "../types/clients-module-types";
import { NoContent } from "../../SharedModule/components/NoContent";
import image from "./../../styles/legacy/404.png";
import { useClientKeyContacts } from "../hooks/useClientKeyContacts";
import {
  getAdvocacyString,
  getRelationshipTrend,
} from "../utils/keyContactUtils";
import { BiLeftArrowAlt } from "react-icons/bi";
import { ModalPortal } from "../../SharedModule/components/ModalPortal";
import { ModalAddNewKeyContact } from "../components/ModalAddNewKeyContact";
import {
  changeOrder,
  SelectOrderCriteria,
  setIsLoadingActualKeyContactData,
} from "../redux/reducers/clientKeyContacts.reducer";
import { resetScrollY } from "../../SharedModule/utils/pagesUtils";

export const ClientKeyContactListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const sortBy = useSelector(SelectOrderCriteria);

  const { id, relationshipReviewId } = useParams();

  // If there is no id, go to clients list
  if (!id) navigate(ROUTE_CLIENTS);

  let routeBack = ROUTE_CLIENTS_RELATIONSHIP_REVIEW_TAB.replace(
    ":id",
    id ?? ""
  );
  if (!relationshipReviewId)
    navigate(routeBack, {
      state: {
        from:
          location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
            ? ROUTE_CLIENTS_RELATIONSHIP_REVIEW
            : "",
      },
    });

  const {
    ClientForHeaderInfo,
    isLoadingKeyContacts,
    actualRelationshipReviewName,
    actualRelationshipReviewStatus,
    keyContactList,
    userRolesList,
    rolesLoaded,
    clientContactsInfo,
    isLoadingContacts,
    isApplySupervisorCheck,
    costCenterOwnedIds,
    clientRelationshipReview,
    isApplyEngagementLeadCheck,
  } = useClientKeyContacts(Number(id), Number(relationshipReviewId));

  useEffect(() => {
    document.title = "The Hub - Key Contacts";

    dispatch(setActiveTab(ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS));

    dispatch(
      changeOrder({
        orderBy: "lastName",
        dataType: "string",
        criteria: "asc",
      })
    );

    return () => {
      resetScrollY(globalThis.location.pathname);
    };
  }, []);

  const goToKeyContactProfile = (keyContact: ClientKeyContact) => {
    let url = ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS.replace(
      ":id",
      id ?? ""
    )
      .replace(":relationshipReviewId", relationshipReviewId ?? "")
      .replace(":keyContactId", String(keyContact.id));
    dispatch(setIsLoadingActualKeyContactData(true));
    navigate(url, {
      state: {
        from:
          location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
            ? ROUTE_CLIENTS_RELATIONSHIP_REVIEW
            : "",
      },
    });
  };

  // Modal config
  const modalRef = useRef<undefined>(undefined);
  const showAddModal = () => {
    (modalRef.current as any).show(true);
  };
  const closeAddModal = () => {
    (modalRef.current as any).show(false);
  };

  const isAbleToAddKeyContac = () => {
    let actualRelationship = clientRelationshipReview.find(
      (rr) => rr.id === Number(relationshipReviewId)
    );
    return (
      verifyModuleAccess(
        true,
        [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
        userRolesList
      ) ||
      (isApplySupervisorCheck &&
        costCenterOwnedIds.includes(actualRelationship?.costCenterId)) ||
      isApplyEngagementLeadCheck
    );
  };

  return (
    <>
      <ModalPortal ref={modalRef}>
        <ModalAddNewKeyContact
          btnCancel={closeAddModal}
          companyId={id}
          relationshipReviewId={relationshipReviewId}
          isLoadingContacts={isLoadingContacts}
          clientContactsInfo={clientContactsInfo}
          keyContactList={keyContactList}
        />
      </ModalPortal>
      <div className="content">
        <HeaderClientsModule
          isLoadingPage={isLoadingKeyContacts || !rolesLoaded}
          backFromRelationshipPage={
            location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
          }
        />

        {(isLoadingKeyContacts || !rolesLoaded) && (
          <Spinner
            style={{
              marginLeft: "50%",
              marginTop: "5%",
            }}
          />
        )}

        {!isLoadingKeyContacts &&
          rolesLoaded &&
          !verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
            <ForbiddenPage />
          )}

        {!isLoadingKeyContacts &&
          rolesLoaded &&
          verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
            <>
              <div
                className="d-flex justify-content-between"
                style={{ margin: "1%" }}
              >
                <div className="d-flex flex-column">
                  <Link
                    className="back-button-container text-decoration-none ps-4"
                    to={routeBack}
                    state={{
                      from:
                        location.state?.from ===
                        ROUTE_CLIENTS_RELATIONSHIP_REVIEW
                          ? ROUTE_CLIENTS_RELATIONSHIP_REVIEW
                          : "",
                    }}
                  >
                    <BiLeftArrowAlt className="back-button-arrow" />
                    <span className="back-button-text">
                      Back to Relationship Review List Tab
                    </span>
                  </Link>
                  <h3 style={{ marginTop: "0.5rem" }}>
                    {actualRelationshipReviewName}{" "}
                    {!actualRelationshipReviewStatus && (
                      <span className="bagde inactive-bagde">Inactive</span>
                    )}
                    <span className="count-amount">
                      ( {keyContactList.length} contacts )
                    </span>
                  </h3>
                </div>
                {ClientForHeaderInfo?.isActive && isAbleToAddKeyContac() && (
                  <button
                    className="btn btn-primary"
                    style={{ marginTop: "35px" }}
                    type="button"
                    onClick={() => showAddModal()}
                    disabled={!actualRelationshipReviewStatus}
                  >
                    Add Key Contact
                  </button>
                )}
              </div>

              {!isLoadingKeyContacts && keyContactList.length === 0 && (
                <div className="py-5">
                  <NoContent
                    title="No Key Contacts for this Relationship Review"
                    image={image}
                    style={{ margin: "0 auto" }}
                  />
                </div>
              )}

              {!isLoadingKeyContacts && keyContactList.length > 0 && (
                <table
                  className="table grey-table-header-background mb-7"
                  style={{ width: "100%" }}
                >
                  <thead className="align-middle sticky sticky-header">
                    <tr>
                      <th
                        className={`border-dark border-top fw-600 ps-3 column-15 pointer ${
                          sortBy.orderBy === "lastName"
                            ? "sorted-" + sortBy.criteria
                            : ""
                        }`}
                        id="lastName"
                        key="lastName"
                        onClick={() =>
                          dispatch(
                            changeOrder({
                              orderBy: "lastName",
                              dataType: "string",
                            })
                          )
                        }
                      >
                        Contact Name
                      </th>
                      <th
                        className="border-dark border-top fw-600 text-center column-15 pointer"
                        id="contactRoles"
                      >
                        Role
                      </th>
                      <th
                        className={`border-dark border-top fw-600 text-center column-15 pointer ${
                          sortBy.orderBy === "confidenceValue"
                            ? "sorted-" + sortBy.criteria
                            : ""
                        }`}
                        id="confidenceValue"
                        key="confidenceValue"
                        onClick={() =>
                          dispatch(
                            changeOrder({
                              orderBy: "confidenceValue",
                              dataType: "number",
                            })
                          )
                        }
                      >
                        Confidence Value
                      </th>
                      <th
                        className={`border-dark border-top fw-600 text-center column-15 pointer ${
                          sortBy.orderBy === "relationshipLevel"
                            ? "sorted-" + sortBy.criteria
                            : ""
                        }`}
                        id="relationshipLevel"
                        key="relationshipLevel"
                        onClick={() =>
                          dispatch(
                            changeOrder({
                              orderBy: "relationshipLevel",
                              dataType: "string",
                            })
                          )
                        }
                      >
                        Relationship Level
                      </th>
                      <th
                        className={`border-dark border-top fw-600 text-center column-15 pointer ${
                          sortBy.orderBy === "discProfile"
                            ? "sorted-" + sortBy.criteria
                            : ""
                        }`}
                        id="discProfile"
                        key="discProfile"
                        onClick={() =>
                          dispatch(
                            changeOrder({
                              orderBy: "discProfile",
                              dataType: "string",
                            })
                          )
                        }
                      >
                        DISC Profile
                      </th>
                      <th
                        className={`border-dark border-top fw-600 ps-5 column-15 pointer ${
                          sortBy.orderBy === "primaryRelationshipSteward"
                            ? "sorted-" + sortBy.criteria
                            : ""
                        }`}
                        id="primaryRelationshipSteward"
                        key="primaryRelationshipSteward"
                        onClick={() =>
                          dispatch(
                            changeOrder({
                              orderBy: "primaryRelationshipSteward",
                              dataType: "string",
                            })
                          )
                        }
                      >
                        Relationship Steward
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {keyContactList.map((keyContact: ClientKeyContact) => {
                      return (
                        <tr
                          key={keyContact.id}
                          className="keyContactRow product-link"
                          onClick={() => goToKeyContactProfile(keyContact)}
                        >
                          <td className="key-contact pointer vert-middle td-shadow-effect">
                            <div className="key-contact-name-rol">
                              <div className="key-contact-name">
                                {`${keyContact.lastName}, ${keyContact.firstName}`}
                                {!keyContact.isActive && (
                                  <span>
                                    <i> (Inactive)</i>
                                  </span>
                                )}
                                {keyContact.jobTitle && (
                                  <div className="key-contact-title">
                                    {keyContact.jobTitle}
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="vert-middle td-shadow-effect">
                            <div className="d-flex flex-column">
                              {keyContact.contactRoles?.map((role: string) => (
                                <span
                                  key={keyContact.id + role}
                                  className="key-contact-role-block fs-small mb-1"
                                >
                                  {role}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className="vert-middle td-shadow-effect">
                            {keyContact.confidenceValue !== null &&
                              keyContact.confidenceValue > 0 && (
                                <span className="key-contact-role-block">
                                  {keyContact.confidenceValue}
                                </span>
                              )}
                          </td>
                          <td className="vert-middle td-shadow-effect">
                            {keyContact.relationshipLevel &&
                              keyContact.relationshipLevel !== "N/A" && (
                                <span
                                  className={`key-contact-role-block ${getAdvocacyString(
                                    keyContact.relationshipLevel
                                  )}`}
                                >
                                  {getAdvocacyString(
                                    keyContact.relationshipLevel
                                  )}
                                  {getRelationshipTrend(
                                    keyContact.relationshipTrend
                                  ) && (
                                    <span className="trend-arrow">
                                      {getRelationshipTrend(
                                        keyContact.relationshipTrend
                                      )}
                                    </span>
                                  )}
                                </span>
                              )}
                          </td>
                          <td className="vert-middle td-shadow-effect">
                            {keyContact.discProfile && (
                              <span className="key-contact-profile-block">
                                {keyContact.discProfile}
                              </span>
                            )}
                          </td>
                          <td className="key-contact vert-middle td-shadow-effect ps-5">
                            {keyContact.primaryRelationshipSteward && (
                              <div className="key-contact-name-rol">
                                <div className="key-contact-name">
                                  {keyContact.primaryRelationshipSteward}
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        <Footer />
      </div>
    </>
  );
};
